import {
  BusinessRounded,
  ChatRounded,
  PersonRounded,
  SummarizeRounded,
} from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';
import { IntegrationType } from 'generated/graphql';

interface GetIconForIntegrationTypeOptions extends SvgIconProps {
  integrationType: IntegrationType | string;
}

export const getIconForIntegrationType = ({
  integrationType,
  ...iconProps
}: GetIconForIntegrationTypeOptions) => {
  switch (integrationType) {
    case IntegrationType.Feedback:
      return (
        <ChatRounded
          {...iconProps}
          sx={{
            color: 'feedback.label',
            ...iconProps.sx,
          }}
        />
      );
    case IntegrationType.User:
      return (
        <PersonRounded
          {...iconProps}
          sx={{
            color: 'misc.integrations.user',
            ...iconProps.sx,
          }}
        />
      );
    case IntegrationType.Account:
      return (
        <BusinessRounded
          {...iconProps}
          sx={{
            color: 'misc.integrations.account',
            ...iconProps.sx,
          }}
        />
      );
    case IntegrationType.Cohorts:
      return (
        <SummarizeRounded
          {...iconProps}
          sx={{ color: 'text.secondary', ...iconProps.sx }}
        />
      );
    default:
      return null;
  }
};
